import { axiosClient } from '../axiosClient';
import { ActionCard } from './types';

export const getActionCards = () => {
  return axiosClient.get<ActionCard[]>('/intent-action-cards');
};
